export default __webpack_public_path__ + "static/media/servicesbanner.111949e4.webp";